
import { FormHandler } from "./formHandler";
declare global {
    interface Window {
        webflow: any;
    }
}

if (typeof window !== 'undefined') {
    const webflowIsExist = window.webflow && typeof window.webflow === 'object' && !Array.isArray(window.webflow)
    if (webflowIsExist) {
        window.webflow = {
            FormHandler,
            ...window.webflow
        }
    } else {
        (window as unknown as Window).webflow = { FormHandler };
    }

}